import React, { Component } from "react";
import { observer } from "mobx-react";
import { comma, dlvPtnerNm } from "utils/Utils";
import moment from "moment";

@observer
class OrderDetailDeliveryInfo extends Component {

    deliveryInfo = (order) => {

        return (
            <div className="wrap_delivery_info">
                <div className="box_tit">
                    <h2>배달정보</h2>
                    {
                        (order.over) ? <span className="over">과적</span> : null
                    }
                </div>
                <div className="box_info">
                    {
                        (order.dlvStatusFg) ?
                            <>
                                <dl>
                                    <dt>배달업체</dt>
                                    <dd>
                                        {/* {(order.mobileOrderFg == "29" || order.mobileOrderFg == "30") 
                                            ? "배민라이더"
                                            : (order.mobileOrderFg == "31") ? "요기요 라이더"
                                                : (order.mobileOrderFg == "28" && order.dlvPtnerNm == null) ? "배달의민족 주문채널"
                                                    : order.dlvPtnerNm ? order.dlvPtnerNm : "배달업체 정보가 없습니다."
                                        } */}
                                        {dlvPtnerNm(order)}
                                    </dd>
                                    {
                                        (order.mobileOrderFg != "29" && order.mobileOrderFg != "30" && order.mobileOrderFg != "31" && order.mobileOrderFg != "32") ?
                                            (order.mobileOrderFg == "28" && (order.ptnerRiderTel == null && order.ptnerRiderNm == null)) ? 
                                            <>
                                                <dt>라이더</dt>
                                                <dd className="null">라이더 정보가 없습니다.
                                                </dd>
                                            </>
                                            :
                                            <>
                                                <dt>라이더</dt>
                                                <dd className="rider">
                                                    {order.ptnerRiderTel ? order.ptnerRiderTel : "미배정"}/{order.ptnerRiderNm ? order.ptnerRiderNm : "미배정"}
                                                </dd>
                                            </>
                                            :
                                            ""
                                    }
                                    {(order.mobileOrderFg != "29" && order.mobileOrderFg != "30" && order.mobileOrderFg != "31" && order.mobileOrderFg != "32") ?
                                        <>
                                            <dt>총배달비</dt>
                                            <dd>{comma(order.dlvDefFee)}원</dd>
                                        </>
                                        :null
                                    }
                                </dl>
                                {
                                    //자체배달 여기다 추가
                                    (order.mobileOrderFg == "32")
                                    ?
                                    <div className={"progress " + (order.dlvStatusFg === "03" ? "progress2" :  "progress3")}>
                                        <ul>
                                            <li>
                                                <strong className="name delivery_bold">
                                                {
                                                    (!order.dlvStatusFg || order.dlvStatusFg === "04") ? "배달완료" : "배달중"
                                                }
                                                </strong>
                                            </li>
                                        </ul>
                                        <div className="bar">
                                            <div></div>
                                            {
                                                (order.dlvStatusFg === "03" || order.dlvStatusFg === "04") ? <div></div> : null
                                            }
                                            {
                                                order.dlvStatusFg === "04" ? <div></div> : null
                                            }
                                        </div>
                                    </div>
                                    :
                                    <div className={"progress " +
                                        (order.dlvStatusFg === "02"
                                            ? "progress2"
                                            : (order.dlvStatusFg === "04" || order.dlvStatusFg === "03") ? (order.mobileOrderFg == "32") ? "progress2" : "progress3" : "progress1")}>
                                        <ul>
                                            {
                                                <>
                                                    <li>
                                                        <strong className="name">
                                                            {
                                                                /*(!order.dlvStatusFg || order.dlvStatusFg==="00")?"배차중":"배차완료"*/
                                                                (!order.dlvStatusFg || (order.dlvStatusFg === "00" || order.dlvStatusFg === "01")) ?
                                                                    "배차중" :
                                                                    (order.dlvAssignTime != null && order.dlvAssignTime) ? "배차완료" : "배차중"
                                                            }
                                                        </strong>
                                                        <span className="time">
                                                            {(order.dlvAssignTime) ? moment(order.dlvAssignTime, "YYYYMMDDHHmmss").format("HH:mm") : ""}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <strong className={"name " + (order.dlvStatusFg === "03" ? "delivery_bold" : "")}>
                                                            {
                                                                (!order.dlvStatusFg || order.dlvStatusFg === "03") ? "픽업완료" :
                                                                    (order.dlvPickupTime != null && order.dlvPickupTime) ? "픽업완료" : "픽업중"
                                                            }
                                                        </strong>
                                                        <span className="time">
                                                            {(order.dlvPickupTime) ? moment(order.dlvPickupTime, "YYYYMMDDHHmmss").format("HH:mm") : ""}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <strong className={"name " + (order.dlvStatusFg === "04" ? "delivery_bold" : "")}>
                                                            {
                                                                (!order.dlvStatusFg || order.dlvStatusFg === "04") ? "배달완료" : "배달중"
                                                            }
                                                        </strong>
                                                        <span className="time">
                                                            {(order.dlvDeliveryTime) ? moment(order.dlvDeliveryTime, "YYYYMMDDHHmmss").format("HH:mm") : ""}
                                                        </span>
                                                    </li>
                                                </>
                                            }
                                        </ul>
                                        <div className="bar">
                                            <div></div>
                                            {
                                                (order.dlvStatusFg === "03" || order.dlvStatusFg === "04") ? <div></div> : null
                                            }
                                            {
                                                order.dlvStatusFg === "04" ? <div></div> : null
                                            }
                                        </div>
                                    </div>
                                }
                                
                            </>
                            :
                            <p className="done">배달요청내역이 없습니다</p>
                    }
                </div>
            </div>
        )
    }

    selfDeliveryInfo = (order) => {
        return (
            <div className="wrap_delivery_info">
                <div className="box_tit">
                    <h2>배달정보</h2>
                </div>
                <div className="box_info">
                    {
                        (order.dlvStatusFg && order.ptnerRiderNm) ?
                            <>
                                <dl>
                                    <dt>배달업체</dt>
                                    <dd>자체배달원</dd>
                                    <dt>라이더</dt>
                                    <dd>
                                        {order.ptnerRiderNm ? order.ptnerRiderNm : "미배정"}
                                    </dd>
                                </dl>
                                <div className={"progress " +
                                    (order.dlvStatusFg === "03"
                                        ? "progress2"
                                        : order.dlvStatusFg === "04" ? "progress3" : "progress1")}>
                                    <ul>
                                        <li>
                                            <strong className={"name " + (order.dlvStatusFg === "04" ? "delivery_bold" : "")}>
                                                {
                                                    (!order.dlvStatusFg || order.dlvStatusFg === "04") ? "배달완료" : "배달중"
                                                }
                                            </strong>
                                            <span className="time">
                                                {(order.dlvDeliveryTime) ? moment(order.dlvDeliveryTime, "YYYYMMDDHHmmss").format("HH:mm") : ""}
                                            </span>
                                        </li>
                                    </ul>
                                    <div className="bar">
                                        <div></div>
                                        {
                                            (order.dlvStatusFg === "03" || order.dlvStatusFg === "04") ? <div></div> : null
                                        }
                                        {
                                            order.dlvStatusFg === "04" ? <div></div> : null
                                        }
                                    </div>
                                </div>
                            </>
                            :
                            <p className="done">배달요청내역이 없습니다</p>
                    }
                </div>
            </div>
        )
    }


    render() {
        const { order } = this.props;
        return (
            <>
                {
                    (order.dlvTargetCd != null) ? this.deliveryInfo(order) : this.selfDeliveryInfo(order)
                }
            </>
        );
    }
}

export default OrderDetailDeliveryInfo;